<template>
    <div class="layout">
        <LayoutNavbar :workshops="workshops"></LayoutNavbar>
        <!-- list -->
        <Spin class="loading" size="large" fix v-if="spinShow"></Spin>
        <Row :gutter="15" class="layout-item">
            <Col span="6" v-for="item in workshops" :key="item.ws_id" style="padding-bottom:15px;">
                <Card :padding="0" :bordered="false" shadow style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25); cursor: pointer;">
                    <Item :item="item"></Item>
                </Card>
            </Col>
        </Row>
        <LayoutFooter/>
    </div>
</template>
<script>
import LayoutNavbar from './components/navbar.vue';
import LayoutFooter from '@/views/main_components/footer.vue';
import Item from './components/item.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';

export default {
    components: {
        LayoutNavbar,
        LayoutFooter,
        Item
    },
    created() {
        this.$store.commit('upNavbar', 1);
    },
    mounted() {
        //获得所有的车间
        Axios.get(AxiosUrl.workshop.layouts, {
            params: {
                cid: this.$store.state.user.cid,
                page: 1,
                size: 100
            }
        }).then(res => {
            if (res.data.code == 200) {
                this.workshops = res.data.data.list;
            } else {
                console.log(res.data.msg);
            }
        });
    },
    data() {
        return {
            workshops: [],
            spinShow: false
        };
    }
};
</script>
<style lang="less">
.layout {
    .loading {
        background-color: #d7d7d7;
    }
    .layout-item {
        top: -48px;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/layout.vue